import { IcsFeedLinkGenerator } from 'api/types';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<EntityType<IcsFeedLinkGenerator>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const eventIcsFeedLinkGeneratorReducer = createReducer<State, Actions>(initialState, {
  [actions.getEventIcsFeedLinkGenerator.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.getEventIcsFeedLinkGenerator.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.getEventIcsFeedLinkGenerator.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.getEventIcsFeedLinkGenerator.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default eventIcsFeedLinkGeneratorReducer;
